import classnames from 'classnames'
import p from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function TechnologyBlock({ icon, title, description }) {
  return (
    <div className={classnames('container')}>
      <div className="info">
        <div className="block">
          <p className="title">{title}</p>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

TechnologyBlock.icons = {
  react: 'react',
  laravel: 'laravel',
  native: 'native',
  next: 'next',
  node: 'node',
}

TechnologyBlock.propTypes = {
  icon: p.string.isRequired,
  title: p.string.isRequired,
  description: p.string.isRequired,
}

TechnologyBlock = chainDecorators(decorators, TechnologyBlock)

export default TechnologyBlock
